import React, { useEffect, useState, useRef } from 'react';
import { DataGrid, useGridApiRef, ptBR } from '@mui/x-data-grid';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material';
import moment from 'moment';
import DownloadIcon from '@mui/icons-material/FileDownloadOutlined';
import ModalGridDashboardPipeComercial from 'components/Dashboard/VisaoGeral/ModalGridDashboardPipeComercial/ModalGridDashboardPipeComercial';
import { postListaClientesDashboard } from '../../../../../api/dashboard';
import LoaderMain from '../../../../Onboarding/shared/LoaderMain';
import { definicaoDeColunas, definicaoGrupoDeColunas } from '../definicoes-grid/definicoes-grid';
import ModalGridDashboard from '../ModalGridDashboard';
import ButtonMain from '../../../../Onboarding/shared/ButtonMain';
import { nivelUsuarioEnum } from '../../../../../shared/Enums';
import ModalGridDashboardCheckpoints from '../../ModalGridDashboardCheckpoints';
import ModalGridDashboardLimiteComercial from '../../ModalGridDashboardLimiteComercial/ModalGridDashboardLimiteComercial';
import ModalGridDashboardExibirProdutos from '../ModalGridDashboardExibirProdutos';
import ModalGridDashboardVOP from '../../ModalGridDashboardVOP';
import WindowSize from '../../../../../utils/windowSize';
import { limparDocumento, formatarDocumento } from '../../../../../utils/documentoAlfanumerico';
import './styles.scss';

const ClientesDashboard = ({ filtroDashboard, loadingDashFim, dadosUser, clienteAtual, setAlerta }) => {
  const qtdPorPagina = 10;
  const [listaClientes, setListaClientes] = useState([]);
  const [dadosAdicionaisGrid, setDadosAdicionaisGrid] = useState({});
  const [dadosListaCheckPoints, setListaCheckPoints] = useState([]);
  const [selectedCheckpoints, setSelectedCheckpoints] = useState([]);
  const [qtdMaxPaginas, setQtdMaxPaginas] = useState(false);
  const [esconderFooter, setEsconderFooter] = useState(true);
  const [isPending, setIsPending] = useState(false);
  const [modalGrid, setModalGrid] = useState(false);
  const [definicoesGrid, setDefinicoesGrid] = useState({
    colunas: [],
    grupoColunas: []
  });
  const [paginaSelecionada, setPaginaSelecionada] = useState(1);
  const [paginacaoModel, setPaginacaoModel] = useState({
    page: 0,
    pageSize: qtdPorPagina
  });
  const [expandirRetrairGrid, setExpandirRetrairGrid] = useState(true);
  const [modalGridCheckpoints, setModalGridCheckpoints] = useState(false);
  const [ModalGridExibirProdutos, setModalGridExibirProdutos] = useState(false);
  const [modalGridLimiteComercial, setModalGridLimiteComercial] = useState(false);
  const [modalGridPipeComercial, setModalGridPipeComercial] = useState(false);
  const [modalGridVOP, setModalGridVOP] = useState(false);
  const [valuePesquisa, setValuePesquisa] = useState('');

  const [tiposSelecionados, setTiposSelecionados] = useState(['aprovados']);
  const prevPesquisaRef = useRef(valuePesquisa);
  const apiRef = useGridApiRef();
  const [ref, size] = WindowSize();

  // 2) handler para marcar/desmarcar
  const handleTipoChange = event => {
    const { value, checked } = event.target;
    setTiposSelecionados(prev => {
      if (checked) {
        return [...prev, value];
      } else {
        return prev.filter(v => v !== value);
      }
    });
  };

  const aplicarMascaraCnpjLista = lista =>
    Array.isArray(lista)
      ? lista.map(cliente => ({
          ...cliente,
          cnpjCliente: cliente.cnpjCliente ? formatarDocumento(cliente.cnpjCliente) : cliente.cnpjCliente
        }))
      : lista;

  const buscarClientes = async (filtro = '') => {
    const filtroClienteParam = tiposSelecionados.map(v => v.toUpperCase());
    let params = {
      filtro: {
        ...filtroDashboard,
        tipoCliente: filtroClienteParam,
        acoesCheckpoints: selectedCheckpoints,
        filtroCNPJNome: prepararFiltroPesquisa(filtro)
      }
    };
    setIsPending(true);

    postListaClientesDashboard(params)
      .then(res => {
        let lstDados =
          res && res.data.listaClientes && res.data.listaClientes ? res.data.listaClientes : [];
        setQtdMaxPaginas(Math.ceil(parseInt(lstDados.length || 0) / qtdPorPagina));
        setListaClientes(aplicarMascaraCnpjLista(lstDados));
        setPaginaSelecionada(1);
        setPaginacaoModel({ page: 0, pageSize: qtdPorPagina });
        if (res && res.data && res.data.media_totais) {
          setDadosAdicionaisGrid({ dadosMedias: res.data.media_totais });
        }
        if (res && res.data && res.data.listaCheckPoint) {
          setListaCheckPoints(res.data.listaCheckPoint);
        }
      })
      .catch(error => {
        const mensagemError =
          (error.response && error.response.data && error.response.data.mensagem) ||
          'Houve um erro ao buscar da Grid. Favor contatar o suporte.';
        setAlerta({
          mensagem: mensagemError,
          tipo: 'error'
        });
        setListaClientes([]);
        setIsPending(false);
      })
      .finally(() => {
        setIsPending(false);
        loadingDashFim('ClientesDashboard');
      });
  };

  const carregarMaisDados = () => {
    let pageTemp = paginaSelecionada + 1;
    if (pageTemp <= qtdMaxPaginas) {
      setPaginaSelecionada(pageTemp);
    }
  };

  const clickGrupoEconomico = params => {
    setModalGrid({ modal: 'grupo_economico', modalTitle: 'Grupo Empresarial', params });
  };

  const handleKeyDown = async event => {
    if (event.key === 'Enter') {
      await buscarClientes(event.target.value);
    }
  };

  const clickStatus = params => {
    setModalGrid({ modal: 'status', modalTitle: 'Status', params });
  };

  const clickParecer = params => {
    setModalGrid({ modal: 'parecer', modalTitle: 'Pareceres', params });
  };

  const clickExibirProdutos = params => {
    setModalGridExibirProdutos({ params });
  };

  const clickCheckpoints = params => {
    setModalGridCheckpoints({
      cnpjCliente: params.cnpjCliente,
      nomeCliente: params.nomeCliente,
      modal: 'checkpoints',
      modalTitle: 'Checkpoints Negócios',
      ckeckpointsClientes: true,
      params
    });
  };

  const clickLimiteComercial = params => {
    setModalGridLimiteComercial({
      cnpjCliente: params.cnpjCliente,
      nomeCliente: params.nomeCliente,
      modal: 'limiteComercial',
      modalTitle: 'Limite Comercial',
      params
    });
  };

  const clickPipeComercial = params => {
    setModalGridPipeComercial({
      cnpjCliente: params.cnpjCliente,
      nomeCliente: params.nomeCliente,
      modal: 'limiteComercial',
      modalTitle: 'Pipe Comercial',
      params
    });
  };

  const clickVOP = params => {
    setModalGridVOP({
      cnpjCliente: params.cnpjCliente,
      nomeCliente: params.nomeCliente,
      modal: 'limiteComercial',
      modalTitle: 'VOP Mensal',
      params
    });
  };

  // const clickVOP = params => {
  //   setModalGridVOP({
  //     cnpjCliente: params.cnpjCliente,
  //     nomeCliente: params.nomeCliente,
  //     modal: 'limiteComercial',
  //     modalTitle: 'Limite Comercial',
  //     params
  //   });
  // };

  const expandeRetraiFunc = () => {
    setExpandirRetrairGrid(expandirRetrairGrid ? false : true);
  };

  const prepararFiltroPesquisa = valor => {
    const texto = String(valor || '').trim();
    const pareceDocumento = /\d/.test(texto) && !/\s/.test(texto) && /^[0-9A-Za-z.\-/]+$/.test(texto);
    return pareceDocumento ? limparDocumento(texto) : texto;
  };

  const produtos =
    listaClientes.length > 0
      ? Object.entries(listaClientes[0].infoProdutos).map(([codProduto, info]) => ({
          codProduto,
          siglaProduto: info.siglaProduto
        }))
      : [];

  const produtosGrid = parseInt(dadosUser.nivel) === nivelUsuarioEnum.CLIENTE ? [] : produtos;

  useEffect(() => {
    if (listaClientes.length === 0) return;
    configuraColunasGrid();
  }, [listaClientes, expandirRetrairGrid, dadosAdicionaisGrid, size]);

  const configuraColunasGrid = () => {
    if (filtroDashboard && filtroDashboard.filtrar === false) return false;
    let configColumnsTemp = definicaoDeColunas({
      clickCheckpoints,
      clickLimiteComercial,
      clickPipeComercial,
      clickVOP,
      clickGrupoEconomico,
      clickStatus,
      clickParecer,
      clickExibirProdutos,
      filtroDashboard,
      dadosUser,
      expandirRetrairGrid,
      expandeRetraiFunc,
      dadosAdicionaisGrid,
      clienteAtual,
      produtos: produtosGrid
    });

    let configGroupColumnsTemp = definicaoGrupoDeColunas({
      filtroDashboard,
      dadosUser,
      expandirRetrairGrid,
      dadosAdicionaisGrid,
      produtos: produtosGrid
    });

    if (expandirRetrairGrid) {
      let novasColunas = [];
      let colunasProdutosRemover = [
        'limite_intercompany',
        'limite_giro_rapido',
        'limite_giro_parcelado',
        'limite_conta_escrow',
        'limite_escrow_simples',
        'limite_capital_flow_partner',
        'risco_intercompany',
        'risco_giro_rapido',
        'risco_giro_parcelado',
        'risco_conta_escrow',
        'risco_escrow_simples',
        'risco_capital_flow_partner',
        'disponivel_giro_rapido',
        'disponivel_intercompany',
        'disponivel_giro_parcelado',
        'disponivel_conta_escrow',
        'disponivel_escrow_simples',
        'disponivel_capital_flow_partner'
      ];

      configColumnsTemp.map(function(coluna) {
        if (!colunasProdutosRemover.includes(coluna.field)) {
          novasColunas.push(coluna);
        }
        return coluna;
      });
      configColumnsTemp = novasColunas;
    }
    if (produtosGrid.length === 0) {
      const allFlex = configColumnsTemp.map(col => ({
        ...col,
        flex: 1,
        minWidth: undefined,
        width: undefined
      }));
      setDefinicoesGrid({
        grupoColunas: configGroupColumnsTemp,
        colunas: allFlex
      });
      return;
    }
    // Dentro da sua função de configuração de colunas (por exemplo, configuraColunasGrid):
    const idxAcoes = configColumnsTemp.findIndex(c => c.field === 'tipoStatus');
    const validadorResultadoIdx = Math.max(idxAcoes, 1);
    const fixedCount = validadorResultadoIdx + 1;
    const larguraBase = size.width / fixedCount;

    // Ajustes de largura por field
    const ajustesPorField = {
      nomeCliente: 80,
      porteCliente: -20,
      qtdProduto: -20,
      risco: -15,
      diasVencimento: -20
    };

    // Colunas fixas (antes de 'tipoStatus')
    const colsFlex = configColumnsTemp.slice(0, fixedCount).map(col => {
      const ajuste = ajustesPorField[col.field] || 0;
      const computedWidth = larguraBase + ajuste;

      return {
        ...col,
        flex: 0,
        width: computedWidth
      };
    });

    const colsScroll = configColumnsTemp.slice(idxAcoes + 1).map(col => ({
      ...col,
      flex: 0,
      width: col.minWidth || 100
    }));

    setDefinicoesGrid({
      grupoColunas: configGroupColumnsTemp,
      colunas: [...colsFlex, ...colsScroll]
    });
  };

  const mdValue =
    clienteAtual &&
    clienteAtual.id === 'todos' &&
    dadosUser &&
    parseInt(dadosUser.nivel) !== nivelUsuarioEnum.CLIENTE
      ? 3
      : 4;

  useEffect(() => {
    configuraColunasGrid();
  }, [expandirRetrairGrid, dadosAdicionaisGrid, size]);

  useEffect(() => {
    if (paginaSelecionada === 1) return false;
    let pageSizeTemp = paginaSelecionada * qtdPorPagina;
    pageSizeTemp = pageSizeTemp < 100 ? pageSizeTemp : 100;
    setPaginacaoModel({ page: 0, pageSize: pageSizeTemp });
  }, [paginaSelecionada]);

  useEffect(() => {
    if (filtroDashboard && filtroDashboard.filtrar === false) return false;
    configuraColunasGrid();
    buscarClientes();
  }, [filtroDashboard, selectedCheckpoints, tiposSelecionados]);

  useEffect(() => {
    if (listaClientes.length > 100 && paginacaoModel.pageSize === 100) {
      setEsconderFooter(false);
    } else {
      setEsconderFooter(true);
    }
  }, [paginacaoModel, listaClientes]);

  useEffect(() => {
    // se antes tinha texto e agora está vazio, chama buscarClientes
    if (valuePesquisa === '' && prevPesquisaRef.current !== '') {
      buscarClientes();
    }
    prevPesquisaRef.current = valuePesquisa;
  }, [valuePesquisa]);

  const CheckClientesAprovadosComponente = () => {
    return (
      <Box className="float-left">
        <Typography variant="subtitle2" className="texto-input">
          Mostrar
        </Typography>
        <FormControl component="fieldset" className="checkbox-form-control">
          <FormControlLabel
            control={
              <Checkbox
                className="checkbox-filtros"
                size="small"
                value="aprovados"
                checked={tiposSelecionados.includes('aprovados')}
                onChange={handleTipoChange}
              />
            }
            label="Aprovados"
          />
          <FormControlLabel
            control={
              <Checkbox
                className="checkbox-filtros"
                size="small"
                value="bloqueados"
                checked={tiposSelecionados.includes('bloqueados')}
                onChange={handleTipoChange}
              />
            }
            label="Bloqueados"
          />
          <FormControlLabel
            control={
              <Checkbox
                className="checkbox-filtros"
                size="small"
                value="inativos"
                checked={tiposSelecionados.includes('inativos')}
                onChange={handleTipoChange}
              />
            }
            label="Inativos"
          />
        </FormControl>
      </Box>
    );
  };

  function CustomNoRowsOverlay() {
    return (
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography variant="subtitle1">Nenhum registro encontrado</Typography>
      </Box>
    );
  }

  return (
    <Box
      className="ajuste-spin-data-grid clientes-dashboard-container"
      sx={isPending ? { position: 'relative' } : {}}
    >
      {isPending && <LoaderMain tipoLoader="float" tipoImagem="circulo" />}
      {listaClientes !== false && !isPending ? (
        <>
          <Grid
            className="container-filtros"
            container
            spacing={2}
            direction={{ xs: 'column', sm: 'row' }}
            ref={ref}
          >
            <Grid item xs={12} sm={6} md={mdValue} className="input-grupo-filtros">
              <Typography variant="subtitle2" className="texto-input">
                Buscar por
              </Typography>
              <TextField
                size="small"
                placeholder="Digite nome ou CPF/CNPJ "
                fullWidth
                className="inputGridCliente"
                onKeyDown={handleKeyDown}
                value={valuePesquisa}
                onChange={e => {
                  const valorDigitado = e.target.value;
                  const pareceDocumento =
                    /\d/.test(valorDigitado) &&
                    !/\s/.test(valorDigitado) &&
                    /^[0-9A-Za-z.\-/]+$/.test(valorDigitado);
                  setValuePesquisa(pareceDocumento ? formatarDocumento(valorDigitado) : valorDigitado);
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon />
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
            {clienteAtual &&
              clienteAtual.id === 'todos' &&
              dadosUser &&
              parseInt(dadosUser.nivel) !== nivelUsuarioEnum.CLIENTE && (
                <Grid item xs={12} sm={6} md={mdValue} className="input-grupo-filtros">
                  <Typography variant="subtitle2" className="texto-input">
                    Buscar por ações de checkpoint
                  </Typography>
                  <FormControl size="small" fullWidth required>
                    <Select
                      multiple
                      displayEmpty
                      className="inputGridCliente"
                      value={selectedCheckpoints}
                      onChange={e => setSelectedCheckpoints(e.target.value)}
                      disabled={dadosListaCheckPoints.length === 0}
                      renderValue={selected => {
                        if (dadosListaCheckPoints.length === 0) {
                          return <>Nenhum checkpoint encontrado</>;
                        }
                        if (selected.length === 0) {
                          return <>Selecione uma opção</>;
                        }
                        const selectedDescriptions = selected.map(tag => {
                          const selecionado = dadosListaCheckPoints.find(item => item.tag === tag);
                          return selecionado ? selecionado.descricao : tag;
                        });
                        return (
                          <Box className="btnLimparConteudo">
                            <span>{selectedDescriptions.join(', ')}</span>
                            <IconButton
                              onMouseDown={event => {
                                event.stopPropagation();
                                event.preventDefault();
                              }}
                              onClick={event => {
                                event.stopPropagation();
                                setSelectedCheckpoints([]);
                              }}
                              size="small"
                            >
                              <ClearIcon fontSize="small" />
                            </IconButton>
                          </Box>
                        );
                      }}
                    >
                      {dadosListaCheckPoints.length > 0 ? (
                        <MenuItem value="">Selecione uma opção</MenuItem>
                      ) : (
                        <MenuItem value="">Nenhum checkpoint encontrado</MenuItem>
                      )}
                      {dadosListaCheckPoints.map(checkpoint => (
                        <MenuItem key={checkpoint.tag} value={checkpoint.tag}>
                          {checkpoint.descricao}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}
            {/* Filtro "Mostrar" */}
            {clienteAtual &&
              clienteAtual.id === 'todos' &&
              dadosUser &&
              parseInt(dadosUser.nivel) !== nivelUsuarioEnum.CLIENTE && (
                <Grid item xs={12} sm={6} md={2} className="input-grupo-filtros">
                  <CheckClientesAprovadosComponente />
                </Grid>
              )}
            {apiRef && (
              <Grid item xs={12} sm={6} md={2} className="input-grupo-filtros-export">
                <Box className="float-right">
                  <ButtonMain
                    tipoBotao="transparente-com-bordas-principal"
                    startIcon={<DownloadIcon />}
                    className="exportarGridClientes"
                    onClick={() =>
                      apiRef.current.exportDataAsCsv({
                        fileName: 'Pipeline | Carteira | ' + moment().format('DDMMYYYY'),
                        delimiter: ';',
                        utf8WithBom: true
                      })
                    }
                  >
                    Exportar
                  </ButtonMain>
                </Box>
              </Grid>
            )}
          </Grid>
          <Box sx={{ width: '100%', overflowX: 'auto' }}>
            <DataGrid
              className="data-grid-clientes-dashboard data-grid-column-group data-grid-separator-header-hidden"
              columns={definicoesGrid.colunas}
              columnGroupingModel={definicoesGrid.grupoColunas}
              experimentalFeatures={{
                columnGrouping: true
              }}
              rows={listaClientes}
              paginationModel={paginacaoModel}
              onPaginationModelChange={setPaginacaoModel}
              pageSizeOptions={[100]}
              getRowHeight={() => 'auto'}
              autoHeight
              disableColumnMenu
              disableRowSelectionOnClick
              slots={{ noRowsOverlay: CustomNoRowsOverlay }}
              localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
              hideFooter={esconderFooter}
              apiRef={apiRef}
              sx={{ width: '100%' }}
            />
          </Box>
          {esconderFooter && (
            <Grid container>
              <Grid item xl={5} lg={5} md={4} sm={2} xs={0} />
              <Grid item xl={2} lg={2} md={4} sm={5} xs={12}>
                {paginaSelecionada < qtdMaxPaginas && (
                  <ButtonMain
                    type="button"
                    tipoBotao="transparente-com-bordas-principal"
                    onClick={() => carregarMaisDados()}
                    disabled={isPending}
                  >
                    <Box>
                      <Box className="display-inline-block">Carregar Mais</Box>
                    </Box>
                  </ButtonMain>
                )}
              </Grid>
              <Grid
                item
                xl={5}
                lg={5}
                md={4}
                sm={5}
                xs={12}
                className="flex-box items-centralizados-direita pad-right-left-5"
              >
                <span className="font-size-1-rem texto-cor-cinza-escuro margin-right-7">Clientes:</span>
                <span className="font-size-1-3-rem texto-cor-principal texto-weight-600">
                  {`${String(
                    paginacaoModel.pageSize < listaClientes.length
                      ? paginacaoModel.pageSize
                      : listaClientes.length
                  ).padStart(2, '0')}`}
                </span>
                <span className="font-size-1-rem texto-cor-principal margin-top-2">
                  {`/${String(listaClientes.length).padStart(2, '0')}`}
                </span>
              </Grid>
            </Grid>
          )}
        </>
      ) : (
        <div className="error">
          <h1>Ops!</h1>
          <p>Alguma coisa deu errado, contate a equipe de suporte.</p>
        </div>
      )}
      <ModalGridDashboard modalGrid={modalGrid} setModalGrid={setModalGrid} />

      {ModalGridExibirProdutos && (
        <ModalGridDashboardExibirProdutos
          ModalGridExibirProdutos={ModalGridExibirProdutos}
          setModalGridExibirProdutos={setModalGridExibirProdutos}
          listaClientes={listaClientes}
          setListaClientes={setListaClientes}
          dadosUser={dadosUser}
          setAlerta={setAlerta}
        />
      )}

      {modalGridCheckpoints && (
        <ModalGridDashboardCheckpoints
          modalGridCheckpoints={modalGridCheckpoints}
          setModalGridCheckpoints={setModalGridCheckpoints}
          listaClientes={listaClientes}
          setListaClientes={setListaClientes}
        />
      )}
      {modalGridLimiteComercial && (
        <ModalGridDashboardLimiteComercial
          modalGridLimiteComercial={modalGridLimiteComercial}
          setModalGridLimiteComercial={setModalGridLimiteComercial}
          setListaClientes={setListaClientes}
          clienteAtual={clienteAtual}
          dadosUser={dadosUser}
          setAlerta={setAlerta}
        />
      )}
      {modalGridPipeComercial && (
        <ModalGridDashboardPipeComercial
          modalGridPipeComercial={modalGridPipeComercial}
          setModalGridPipeComercial={setModalGridPipeComercial}
          listaClientes={listaClientes}
          setListaClientes={setListaClientes}
          setAlerta={setAlerta}
        />
      )}
      {modalGridVOP && (
        <ModalGridDashboardVOP
          modalGridVOP={modalGridVOP}
          setModalGridVOP={setModalGridVOP}
          listaClientes={listaClientes}
          setAlerta={setAlerta}
        />
      )}
    </Box>
  );
};

export default ClientesDashboard;
